export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/8e8641da5546a83267ff7cb844712535.svg";